import { withTranslation } from "react-i18next";
import Alert from "../../components/Alert/Alert";

function Errors({ t, errors }) {

    return errors && errors.length ?
        <div className="mb-6">
            <Alert type="error" title={t("An error occured")}
                description={errors && typeof (errors) !== 'boolean' ?
                    typeof errors === "string" ?
                        errors :
                        <ul className="list-disc space-y-1 w-full text-left">
                            {errors.map(err => <li>{err}</li>)}
                        </ul>
                    : null}
            />
        </div> : null;

}

export default withTranslation()(Errors);